export default {
  title: {
    list: 'Company Culture'
  },
  label: {
    companyCulture: 'Company Culture',
    cultureBenchmark: 'culture benchmark',
    assessmentIntroOne: `The Company Culture Benchmark has successfully been updated"The purpose of this step is to identify the culture of your company. 
      Culture is how a company really operates on a daily basis, it's the combination of what people in the company care about, how they work together, standards of behavior, and what makes someone successful in the company. 
      You might think of it as the personality of the company. The outcome of this step is a culture benchmark against which you can compare applicants and quickly identify those who best fit your company's culture.`,
    assessmentIntroTwo: `To complete this step, drag the values from the left side margin to corresponding panel to identify those which are important, unimportant and neutral to the IDEAL WORKPLACE at your company. 
      Once all values have been allocated, you will then be asked to identify the three (3) MOST important values and three (3) LEAST important values.
       Which panel you assign each value to is meaningful and will impact which applicants are identified as being a good fit to your company.`,
    unimportantUpperCase: 'UNIMPORTANT',
    neutralUpperCase: 'NEUTRAL',
    importantUpperCase: 'IMPORTANT '
  },
  message: {
    cultureBenchmarkHasSuccessfully: 'The Company Culture Benchmark has successfully been updated',
    containerAlreadyFull: 'The category is already full! Please remove to others.',
    selectBeyondTheLimit: 'Oops! It seems you have already selected three. Tap again to de-select a value before continuing.'
  },
  button: {
    back: 'BACK',
    close: 'CLOSE'
  }
}
